import type { IconData } from '@stacksjs/iconify-core'

export const photographyPicturePolaroid: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M29.72 3.81h1.52v25.91h-1.52ZM3.81 29.72h25.91v1.52H3.81ZM26.67 2.29h1.52v24.38h-1.52Zm-3.05 12.19h-3.05V16h3.05v4.57h1.53V5.34h-1.53zm-3.05 4.57h-1.52v1.52H5.34v1.53h18.28v-1.53h-3.05zM19.05 16h1.52v1.53h-1.52Zm-1.52 1.53h1.52v1.52h-1.52Z\"/><path fill=\"currentColor\" d=\"M17.53 12.95h3.04v-1.52h1.53V8.38h-1.53V6.86h-3.04v1.52H16v3.05h1.53zM16 16h1.53v1.53H16Zm-1.52-1.52H16V16h-1.52Zm-1.52-1.53h1.52v1.53h-1.52Zm-3.05-1.52h3.05v1.52H9.91Zm-1.53 1.52h1.53v1.53H8.38Zm-1.52 1.53h1.52V16H6.86ZM5.34 3.81h18.28v1.53H5.34Zm0 13.72h1.52V16H5.34V5.34H3.81v15.23h1.53zM2.29.76h24.38v1.53H2.29Zm0 25.91h24.38v1.52H2.29ZM.76 2.29h1.53v24.38H.76Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default photographyPicturePolaroid
